const options = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
};

const dateToString = (date) => new Date(date).toLocaleDateString('en-US', options);

export default dateToString;
